export const STATUS_PARAMS = {
  deleted: 'DELETED',
  added: 'ADDED',
  approved: 'APPROVED',
  changed: 'CHANGED'
} as const

export const FILTERS_PARAMS_KEYS = {
  monitoringKindIds: 'monitoringKindIds',
  monitoringTypeIds: 'monitoringTypeIds',
  monitoringSubtypeIds: 'monitoringSubtypeIds',
  excludedMonitoringKindIds: 'excludedMonitoringKindIds',
  excludedMonitoringSubtypeIds: 'excludedMonitoringSubtypeIds',
  excludedMonitoringTypeIds: 'excludedMonitoringTypeIds',
  storeIds: 'storeIds',
  excludedStoreIds: 'excludedStoreIds',
  clusterIds: 'clusterIds',
  excludedClusterIds: 'excludedClusterIds',
  clustersGroupIds: 'clustersGroupIds',
  excludedClustersGroupIds: 'excludedClustersGroupIds',
  salesOrganizationIds: 'salesOrganizationIds',
  excludedSalesOrganizationIds: 'excludedSalesOrganizationIds',
  contractorIds: 'contractorIds',
  excludedContractorIds: 'excludedContractorIds',
  id: 'id',
  regions: 'regions',
  competitorIds: 'competitorIds',
  productCodes: 'productCodes',
  productCode: 'productCode',
  productName: 'productName',
  competitorNetworkIds: 'competitorNetworkIds',
  period: 'period',
  createdAtAfter: 'createdAtAfter',
  createdAtBefore: 'createdAtBefore',
  createdAtFrom: 'createdAtFrom',
  createdAtTo: 'createdAtTo',
  collectedDateAtAfter: 'collectedDateAtAfter',
  collectedDateAtBefore: 'collectedDateAtBefore',
  deadlineFrom: 'deadlineFrom',
  deadlineTo: 'deadlineTo',
  deadlineBefore: 'deadlineBefore',
  deadlineAfter: 'deadlineAfter',
  archivedAtBefore: 'archivedAtBefore',
  archivedAtAfter: 'archivedAtAfter',
  status: 'status',
  statuses: 'statuses',
  trendIds: 'trendIds',
  trendCode: 'trendCode',
  trendCodes: 'trendCodes',
  purchasingGroupIds: 'purchasingGroupIds',
  purchasingGroupCode: 'purchasingGroupCode',
  commodityGroupIds: 'commodityGroupIds',
  commodityGroupCode: 'commodityGroupCode',
  categoriesIds: 'categoriesIds',
  categoryIds: 'categoryIds',
  categoryCode: 'categoryCode',
  subcategoriesIds: 'subcategoriesIds',
  subcategoryCode: 'subcategoryCode',
  matchedWithLentaIds: 'matchedWithLentaIds',
  productCodeLentaIds: 'productCodeLentaIds',
  productNameIds: 'productNameIds',
  week: 'week',
  productsFilterIds: 'productsLentaFilterIds',
  filtersValue: 'filtersValue',
  startPromoDateAt: 'startPromoDateAt',
  endPromoDateAt: 'endPromoDateAt',
  maxDiscount: 'maxDiscount',
  minDiscount: 'minDiscount',
  executorUserIds: 'executorUserIds',
  names: 'names',
  name: 'name',
  priceDifferenceFrom: 'priceDifferenceFrom',
  priceDifferenceTo: 'priceDifferenceTo',
  priceType: 'priceType',
  excludeRangePriceDifference: 'excludeRangePriceDifference',
  commentsByUsers: 'commentsByUsers',
  showStopped: 'showStopped',
  generalExternalProductIds: 'generalExternalProductIds',
  isConfirmed: 'isConfirmed',
  isMatchedWithProduct: 'isMatchedWithProduct',
  isMatchingStatus: 'isMatchingStatus',
  isCHTM: 'isCHTM',
  isEPP: 'isEPP',
  isInfo: 'isInfo',
  isShortKvi: 'isShortKvi',
  isTop1: 'isTop1',
  executor: 'executor',
  taskTypes: 'taskTypes',
  abnormalState: 'abnormalState',
  switchLogicalOperator: 'switchLogicalOperator',
  productNames: 'productNames',
  state: 'state',
  monitoringStartAtAfter: 'monitoringStartAtAfter',
  monitoringStartAtBefore: 'monitoringStartAtBefore',
  promoIds: 'promoIds',
  excludedPromoIds: 'excludedPromoIds'
} as const

export const QUERY_PARAMS_KEYS = {
  id: 'id'
} as const

export const MONITORING_CLASS = {
  REGULAR: 'REGULAR',
  IRREGULAR: 'IRREGULAR',
  PROMO_CHECK: 'PROMO_CHECK',
  TOTAL_CHECK: 'TOTAL_CHECK'
} as const

export const MONITORING_STATUS = {
  NEW: 'NEW',
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED',
  CHANGED: 'CHANGED',
  RECOMMENDED_CHANGE: 'RECOMMENDED_CHANGE'
} as const

export const MONITORING_STATUS_TITLE = {
  [MONITORING_STATUS.NEW]: 'Новый',
  [MONITORING_STATUS.APPROVED]: 'Согласован',
  [MONITORING_STATUS.NOT_APPROVED]: 'Не согласован',
  [MONITORING_STATUS.CHANGED]: 'Изменен',
  [MONITORING_STATUS.RECOMMENDED_CHANGE]: 'Изменяется'
} as const

export const MONITORING_MATRIX_STATUS = {
  active: 'active',
  activePassive: 'active-passive',
  passive: 'passive',
  deleted: 'deleted'
} as const

export const MONITORING_MATCHING_STATUS = {
  matched: 'matched',
  not_matched: 'not_matched'
} as const

export const MONITORING_PRODUCT_STATUS = {
  DELETED: 'DELETED',
  CHANGED: 'CHANGED',
  ADDED: 'ADDED',
  APPROVED: 'APPROVED'
} as const

export const MONITORING_TASK_STATUS = {
  FORMING: 'FORMING',
  START: 'START',
  IN_PROGRESS: 'IN_PROGRESS',
  PROCESSING: 'PROCESSING',
  NEEDS_CORRECTION: 'NEEDS_CORRECTION',
  NEEDS_VERIFYING: 'NEEDS_VERIFYING',
  VERIFYING: 'VERIFYING',
  SENT_TO_BW: 'SENT_TO_BW',
  SEND_TO_BW_ERROR: 'SEND_TO_BW_ERROR',
  DONE: 'DONE',
  STOPPED: 'STOPPED'
} as const

export const MONITORING_TASK_STATUS_TITLE = {
  [MONITORING_TASK_STATUS.FORMING]: 'Формирование',
  [MONITORING_TASK_STATUS.START]: 'Старт',
  [MONITORING_TASK_STATUS.IN_PROGRESS]: 'В работе',
  [MONITORING_TASK_STATUS.PROCESSING]: 'Обработка',
  [MONITORING_TASK_STATUS.NEEDS_CORRECTION]: 'Требуется корректировка',
  [MONITORING_TASK_STATUS.NEEDS_VERIFYING]: 'Требуется проверка',
  [MONITORING_TASK_STATUS.VERIFYING]: 'На проверке',
  [MONITORING_TASK_STATUS.SENT_TO_BW]: 'Отправлена в BW',
  [MONITORING_TASK_STATUS.SEND_TO_BW_ERROR]: 'Ошибка отправки в BW',
  [MONITORING_TASK_STATUS.DONE]: 'Завершено',
  [MONITORING_TASK_STATUS.STOPPED]: 'Остановлено'
}

export const FILE_TYPES = {
  xlsx: 'xlsx',
  zip: 'zip',
  csv: 'csv'
} as const

export const CONTENT_TYPES = {
  applicationOfficedocumentSpreadsheetml: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  multipartFormData: 'multipart/form-data',
  applicationZip: 'application/zip',
  textCsv: 'text/csv'
} as const

export const MONITORING_TASK_VALIDATION_CONFIG_NAMES = {
  superAbnormalPriceDetectionIsEnabled: 'Процентное отклонение цен',
  abnormalPriceDetectionIsEnabled: 'Выявление аномальных цен',
  recalculationWeightAndVolumeIsEnabled: 'Пересчет веса и объема для цен',
  promoPriceTransitionIsEnabled: 'Перенос цен в промо',
  priceRestorationIsEnabled: 'Восстановление цен',
  priceTranslationIsEnabled: 'Транслирование цен'
} as const

export const PRODUCT_PRICING_STATES = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  DONE: 'DONE'
}

export const MANAGING_MONITORING_PRICING_LEVEL = {
  STORE: 'store',
  CLUSTER: 'cluster'
} as const

export const MANAGING_MONITORING_PRICING_LEVEL_TITLE = {
  [MANAGING_MONITORING_PRICING_LEVEL.STORE]: 'ТК',
  [MANAGING_MONITORING_PRICING_LEVEL.CLUSTER]: 'Кластер'
} as const
